import React from 'react';

import { onAppleStoreClick, onGoogleStoreClick } from 'containers/events';

import FeatureCta from 'components/feature-cta/feature-cta';

type FeatureCtaContainerProps = {
  title: string;
  appLinks?: boolean;
};
export const FeatureCtaContainer: React.FC<FeatureCtaContainerProps> = ({ title, appLinks }) => {
  return (
    <FeatureCta
      title={title}
      appLinks={appLinks}
      onAppleStoreClick={onAppleStoreClick}
      onGoogleStoreClick={onGoogleStoreClick}
    />
  );
};
